import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const chronicBronchitis: AnswerPathTreeNode = {
  path: 'chronicBronchitis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredChronicBronchitisDetails }],
};
